const Mutations = Object.freeze({
	SET_INITIALIZED: 'inventoryFormModule/SET_INITIALIZED',
	SET_INVENTORY_FORMS: 'inventoryFormModule/SET_INVENTORY_FORMS',
	SET_ENTITIES: 'inventoryFormModule/SET_ENTITIES',
	SET_REFERENCE_LIST_TYPES: 'inventoryFormModule/SET_REFERENCE_LIST_TYPES',
	SET_REFERENCE_LIST_VALUES: 'inventoryFormModule/SET_REFERENCE_LIST_VALUES',
	SET_GRID_VIEWS: 'inventoryFormModule/SET_GRID_VIEWS',
});

export const Actions = Object.freeze({
	LOAD_INVENTORY_FORMS: 'inventoryFormModule/LOAD_INVENTORY_FORMS',
	LOAD_REFERENCE_LIST_VALUES:
		'inventoryFormModule/inventoryForm/LOAD_REFERENCE_LIST_VALUES',
	RELOAD: 'inventoryFormModule/RELOAD',
	CLEAR: 'inventoryFormModule/CLEAR',
});

export const Getters = Object.freeze({
	INITIALIZED: 'inventoryFormModule/INITIALIZED',
	MENU_FORMS: 'inventoryFormModule/MENU_FORMS',
	INVENTORY_FORMS: 'inventoryFormModule/INVENTORY_FORMS',
	GET_REFERENCE_LIST_TYPES: 'inventoryFormModule/GET_REFERENCE_LIST_TYPES',
	GET_REFERENCE_LIST_VALUES: 'inventoryFormModule/GET_REFERENCE_LIST_VALUES',
	GET_GRID_VIEWS: 'inventoryFormModule/GET_GRID_VIEWS',
});

import formBuilder from './formBuilder/formBuilder';
import inventoryForm from './inventoryForm';
import inventoryFormGrid from './inventoryFormGrid';
import inventoryFormHistory from './inventoryFormHistory';
import dataService from '../../../../../services/data/inventoryFormService';
import { GeneralActions } from '../../../../actions';

export default {
	state: {
		initialized: false,
		inventoryForms: [],
		entities: [],
		referenceListTypes: [],
		referenceListValues: [],
		gridViews: [],
	},
	modules: {
		formBuilder,
		inventoryForm,
		inventoryFormGrid,
		inventoryFormHistory,
	},
	mutations: {
		[Mutations.SET_INITIALIZED](state, value) {
			state.initialized = value;
		},
		[Mutations.SET_INVENTORY_FORMS](state, items) {
			state.inventoryForms = items;
		},
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_REFERENCE_LIST_TYPES](state, items) {
			state.referenceListTypes = items;
		},
		[Mutations.SET_REFERENCE_LIST_VALUES](state, items) {
			state.referenceListValues = items;
		},
		[Mutations.SET_GRID_VIEWS](state, items) {
			state.gridViews = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_INVENTORY_FORMS, []);
				commit(Mutations.SET_REFERENCE_LIST_VALUES, []);
				commit(Mutations.SET_REFERENCE_LIST_TYPES, []);
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_GRID_VIEWS, []);
				commit(Mutations.SET_INITIALIZED, false);
				resolve();
			});
		},

		[Actions.LOAD_INVENTORY_FORMS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				Promise.all([
					dataService.getEntities().then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
					}),
					dataService.getReferenceListTypes().then((resp) => {
						commit(Mutations.SET_REFERENCE_LIST_TYPES, resp.data);
					}),
					dataService.getReferenceListValues().then((resp) => {
						commit(Mutations.SET_REFERENCE_LIST_VALUES, resp.data);
					}),
					dataService.getInventoryForms().then((resp) => {
						commit(Mutations.SET_INVENTORY_FORMS, resp.data);
					}),
					dataService.getDefaultGridViews().then((resp) => {
						commit(Mutations.SET_GRID_VIEWS, resp.data);
					}),
				])
					.then(() => {
						commit(Mutations.SET_INITIALIZED, true);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.LOAD_REFERENCE_LIST_VALUES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dataService
					.getReferenceListValues()
					.then((resp) => {
						commit(Mutations.SET_REFERENCE_LIST_VALUES, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					});
			});
		},
		[Actions.RELOAD]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_INITIALIZED, true);
				dispatch(Actions.LOAD_INVENTORY_FORMS).then(() => {
					resolve();
				});
			});
		},
	},
	getters: {
		[Getters.INITIALIZED]: (state) => {
			return state.initialized;
		},
		[Getters.MENU_FORMS]: (state) => {
			if (!state.inventoryForms) return [];
			if (state.inventoryForms.length < 0) return [];

			let menuItems = state.inventoryForms.map((x) => {
				return { Id: x.Id, Name: x.Name, Type: x.Type };
			});
			return JSON.parse(JSON.stringify(menuItems));
		},
		[Getters.INVENTORY_FORMS]: (state) => {
			if (!state.inventoryForms) return [];
			if (state.inventoryForms.length < 0) return [];
			return JSON.parse(JSON.stringify(state.inventoryForms));
		},

		[Getters.GET_REFERENCE_LIST_TYPES]: (state) => {
			if (
				state.referenceListTypes &&
				state.referenceListTypes.length > 0
			) {
				return JSON.parse(JSON.stringify(state.referenceListTypes));
			}
			return [];
		},
		[Getters.GET_REFERENCE_LIST_VALUES]: (state) => {
			if (
				state.referenceListValues &&
				state.referenceListValues.length > 0
			) {
				return JSON.parse(JSON.stringify(state.referenceListValues));
			}
			return [];
		},
		[Getters.GET_GRID_VIEWS]: (state) => {
			if (!state.gridViews) return [];
			return JSON.parse(JSON.stringify(state.gridViews));
		},
	},
};
